import {
  AUTO_SIZED_COLUMNS_DEFAULT,
  type TableMergedState,
} from 'components/Table/model/TableModel';

export const selectAutoSizedColumns = (s: TableMergedState): boolean =>
  s.settings.autoSizedColumns ?? AUTO_SIZED_COLUMNS_DEFAULT;
